import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './FaqPage.css'; // Import the CSS file below
import Seo from "../components/Seo";



const FAQ = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });

    const items = document.querySelectorAll('.faq-item');

    const toggleOpen = (event) => {
      event.currentTarget.classList.toggle('open');
    };

    items.forEach((item) => {
      item.addEventListener('click', toggleOpen);
    });

    return () => {
      items.forEach((item) => {
        item.removeEventListener('click', toggleOpen);
      });
    };
  }, []);

  return (  
    <>

     <Seo
        title="Frequently Asked Questions (FAQ) - Mortbuzz Loan Services"
        description="Find answers to common questions about home loans, personal loans, business loans, car loans, and other financial services at Mortbuzz. Clear and simple explanations."
        keywords="mortbuzz FAQ, loan FAQs, home loan questions, personal loan questions, business loan queries, car loan FAQs, loan eligibility questions"
        canonical="https://www.mortbuzz.in/faq-section"
      />

    <div className="faq-container">
      <div className="faq-wrapper">
        <h2 className="faq-title" data-aos="fade-up">
          Frequently Asked Questions
        </h2>

        <div className="faq-list">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="faq-item"
              data-aos="fade-up"
              data-aos-delay={index * 50}
            >
              <h3 className="faq-question">
                {faq.question}
                <span className="arrow">&#x25BC;</span>
              </h3>
              <div className="faq-answer">
                {faq.answer}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    </>
  );
};

const faqData = [
  {
    question: "What is the eligibility criteria for a home loan?",
    answer: "You need stable income, credit score, and valid documents.",
  },
  {
    question: "How much home loan can I get?",
    answer: "Depends on income, liabilities, and property value. Usually 75–90% of cost.",
  },
  {
    question: "What is the maximum tenure for a home loan?",
    answer: "Up to 30 years based on profile.",
  },
  {
    question: "Can I get a home loan for under-construction property?",
    answer: "Yes, funds are disbursed in phases based on project completion.",
  },
  {
    question: "What types of vehicles are eligible for a car loan?",
    answer: "New or used cars, depending on the bank.",
  },
  {
    question: "How much down payment is required?",
    answer: "Typically 10%–25% of the vehicle value.",
  },
  {
    question: "Is it possible to get 100% car loan finance?",
    answer: "Rare, but available for select profiles.",
  },
  {
    question: "Can I prepay or foreclose my car loan?",
    answer: "Yes, though some lenders charge foreclosure fees.",
  },
  {
    question: "Who can apply for a personal loan?",
    answer: "Salaried or self-employed with valid documents and income.",
  },
  {
    question: "Do I need to provide collateral for a personal loan?",
    answer: "No, it is an unsecured loan.",
  },
  
];

export default FAQ;
